import api from '../config/api';
import { InventorySnapshot, InventoryEvent, EventCreatePayload, EventListResponse, TradeCreatePayload, TradeResponse } from '../types';

export const inventoryService = {
  getSnapshots: async (days = 30, gameId?: number): Promise<InventorySnapshot[]> => {
    const params = new URLSearchParams({ days: String(days) });
    if (gameId) params.set('game_id', String(gameId));
    const res = await api.get(`/api/inventory/snapshots?${params.toString()}`);
    return res.data;
  },

  generateSnapshot: async (): Promise<InventorySnapshot> => {
    const res = await api.post('/api/inventory/snapshots/generate');
    return res.data;
  },

  getEvents: async (page = 1, perPage = 20, eventType?: string, search?: string): Promise<EventListResponse> => {
    const params = new URLSearchParams({ page: String(page), per_page: String(perPage) });
    if (eventType) params.set('event_type', eventType);
    if (search) params.set('search', search);
    const res = await api.get(`/api/inventory/events?${params.toString()}`);
    return res.data;
  },

  createEvent: async (data: EventCreatePayload): Promise<InventoryEvent> => {
    const res = await api.post('/api/inventory/events', data);
    return res.data;
  },

  deleteEvent: async (id: number): Promise<void> => {
    await api.delete(`/api/inventory/events/${id}`);
  },

  createTrade: async (data: TradeCreatePayload): Promise<TradeResponse> => {
    const res = await api.post('/api/inventory/trades', data);
    return res.data;
  },

  deleteTrade: async (tradeGroupId: string): Promise<void> => {
    await api.delete(`/api/inventory/trades/${tradeGroupId}`);
  },
};
